// extracted by mini-css-extract-plugin
export default {"root":"UserRegister_root__kMVtF","alert":"UserRegister_alert__oKIkH"};